module.exports = __webpack_public_path__ + "static/media/previewlifestyle3-large.aa18f62e.jpg";